// https://github.com/tc39/proposal-global
var $export = require('./_export');

$export($export.S, 'System', {
  global: require('./_global')
});